if(typeof require('react-native-reanimated') === 'undefined') {var e = new Error("Cannot find module 'require('react-native-reanimated')'"); e.code = 'MODULE_NOT_FOUND'; throw e;}
module.exports = require('react-native-reanimated');